import { useCallback } from 'react'
import ApiService from '../../services/ApiService'

const InteractorReturnSearch = () => {
  const returnSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/transaction-retur-header/search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
      loading(false)
    })
  }, [])
  return { returnSearch }
}

export default InteractorReturnSearch
